<template>
  <SelectableSearch
    :model-value="props.modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
    :options="props.options"
    idKey="id"
    labelKey="building_type_nm"
    :formatter="props.formatter || defaultFormatLabel"
    :getInputLabel="(bt) => bt?.building_type_nm ?? ''"
    :placeholder="props.placeholder || '建物種別またはIDで検索'"
    :required="props.required || false"
  />
</template>

<script setup>
import SelectableSearch from './SelectableSearch.vue'

const props = defineProps({
  modelValue: [String, Number, null],
  options: {
    type: Array,
    required: true
  },
  formatter: Function,
  placeholder: String,
  required: Boolean
})

const emit = defineEmits(['update:modelValue'])

const defaultFormatLabel = (bt) => `${bt.building_type_nm}（ID: ${bt.id}）`
</script>
